import { Menu, MenuButton, MenuItem } from '@szhsin/react-menu';
import styled from 'styled-components';

export const StyledSessionsListSection = styled.div`
  width: 100%;
  min-width: 0;
  min-height: 0;
  padding-bottom: 8px;

  .subheading2 {
    display: block;
    font-size: 14px;
    line-height: 18px;
    font-weight: 500;
    color: var(--on-ink-2);
    margin-bottom: 10px;
  }

  .chat-list {
    list-style: none;
    padding: 0;
    margin: 0;
    color: var(--on-ink);
    font-size: 13px;
    line-height: 16px;
    font-weight: 500;
    margin-bottom: 20px;
    width: 100%;
    min-width: 0;

    > li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 4px;
      position: relative;
      width: 100%;
      max-width: 100%;
      min-width: 0;
      padding: 0 4px 0 0;
      margin: 0 0 8px;
      border-radius: 10px;
      background: rgba(245, 241, 234, 0.08);
      color: var(--on-ink);
      cursor: pointer;
      transition:
        background 0.2s var(--ease),
        color 0.2s var(--ease),
        box-shadow 0.2s var(--ease);
      overflow: hidden;

      &:hover:not(.active) {
        background: rgba(245, 241, 234, 0.12);
      }

      &.active {
        background: var(--orange);
        color: var(--ink);
        box-shadow: 0 0 0 1px var(--o-halo);
      }

      > .text {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex: 1 1 auto;
        min-width: 0;
        max-width: 100%;
        padding: 10px 8px 10px 10px;
        color: inherit;
      }
    }
  }

  .float-dropdown {
    width: 100px;
    position: absolute;
    top: 6px;
    right: 22px;
    padding: 6px 10px;
    border-radius: 10px;
    box-shadow: var(--shadow);
    background: var(--card);
    color: var(--ink);

    .list {
      list-style: none;
      margin: 0;
      padding: 0;
      font-size: 14px;
      line-height: 18px;
      font-weight: 600;
      text-transform: capitalize;

      li {
        display: block;
        padding: 3px 0;
      }

      button {
        padding: 0;
        background: none;
      }
    }
  }
`;

export const MainMenu = styled(Menu)`
  flex-shrink: 0;

  &.szh-menu-container {
    flex-shrink: 0;
  }

  .szh-menu {
    z-index: 120 !important;
    width: 168px;
    padding: 6px;
    border-radius: 12px;
    border: 1px solid var(--ink-line);
    background: var(--ink-panel);
    color: var(--on-ink);
    box-shadow: var(--shadow-lg);
  }
`;

export const MenuBtn = styled(MenuButton)`
  color: var(--on-ink-2);
  position: static;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  padding: 0;
  margin: 0 4px 0 0;
  border-radius: 50%;
  border: 1px solid var(--ink-line);
  background: rgba(245, 241, 234, 0.04);
  cursor: pointer;
  transition:
    color 0.15s var(--ease),
    border-color 0.15s var(--ease),
    background 0.15s var(--ease);

  &:hover,
  &[aria-expanded='true'] {
    color: var(--on-ink);
    border-color: rgba(245, 241, 234, 0.35);
    background: rgba(245, 241, 234, 0.12);
  }

  li.active &,
  li:hover.active & {
    color: var(--ink);
    border-color: rgba(10, 9, 8, 0.25);
    background: rgba(10, 9, 8, 0.12);
  }
`;

export const StyledMenuItem = styled(MenuItem)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 9px 10px;
  border-radius: 8px;
  color: var(--on-ink);
  font-size: 13px;

  button {
    width: 100%;
    text-align: left;
    background: none;
    border: 0;
    color: inherit;
    cursor: pointer;
    font-size: inherit;
  }

  &.active,
  &:hover {
    background: rgba(245, 241, 234, 0.08);
  }

  &:last-child {
    margin: 0;
  }
`;
